import * as React from "react";
import CryptoJS from 'crypto-js';
import Button from "@mui/material/Button";
import {
    Dialog,
    DialogActions,
    DialogContent,
    TextField,
    DialogContentText,
    DialogTitle,
    Select,
    MenuItem, TextareaAutosize
} from "@mui/material";
import autoBind from "auto-bind";
import {ITeam} from "../../project/components/dark_version/ProjectDetails/ProjectTeam";
import FormControl from "@mui/material/FormControl";

interface IProps {
    pid: string
    teams: ITeam[]
}

interface IState {
    open: boolean
    message: string
    selectedMember: ITeam | null
    phoneNo: string | null
}


class SMSDialog extends React.PureComponent <IProps, IState> {
    constructor(props: IProps) {
        super(props);
        autoBind(this);
        this.state = {
            open: false,
            message: "Please update the progress of your project at below link.",
            selectedMember: null,
            phoneNo: null
        }
    }

    modifyPhoneNo(modifiedPhoneNumber: string) {
        // Remove any non-numeric characters
        const cleanedNumber = modifiedPhoneNumber.replace(/\D/g, '');

        // Remove leading zeros
        const cleanedNumberWithoutZeros = cleanedNumber.replace(/^0+/, '');

        // Remove '+' sign if present
        const cleanedNumberWithoutPlus = cleanedNumberWithoutZeros.replace(/^\+/, '');

        // Add country code '92' if missing
        const updatedNumber = cleanedNumberWithoutPlus.startsWith('92') ?
            cleanedNumberWithoutPlus :
            '92' + cleanedNumberWithoutPlus;

        return updatedNumber;
    }

    sendSMS() {
        if (this.state.phoneNo) {
            // const msgDiv = document.getElementById("div-message")
            const pno = this.modifyPhoneNo(this.state.phoneNo)
            alert("Sending SMS to " + pno)
            //@ts-ignore
            const token = CryptoJS.AES.encrypt(pno, process.env.REACT_APP_SECRET_KEY).toString()
            const msgURL: string =`http://localhost:3001/pc_editor?id=${this.props.pid}&token=${encodeURIComponent(token)}`
            const sms_token = process.env.REACT_APP_SMS_TOKEN
            const sms_api_secret = process.env.REACT_APP_SMS_API_SECRET
            const values = {
                "api_token": sms_token,
                "api_secret": sms_api_secret,
                "to": pno,
                "from": 'TheSptlCdrs',
                "message": this.state.message + " " + msgURL

            }

            // alert(JSON.stringify(values))
            const url: string = "https://lifetimesms.com/json"
            //@ts-ignore
            const queryString = new URLSearchParams(values).toString();
            fetch(`${url}?${queryString}`).then((response) => {
                // Check if the request was successful (status code 200)
                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }
                // Parse the JSON in the response
                return response.text();
            }).then((data) => {
                // alert(data)

            }).catch(error => {
                console.error("Fetch error:", error);

            });

        }

    }


    show() {
        this.setState(() => ({open: true}))
    }

    handleClose() {
        this.setState(() => ({open: false}))
    }

    setMessage(msg: string) {
        this.setState(() => ({
            message: msg
        }))
    }

    setPhoneNo(phoneNo: string) {
        this.setState(() => ({
            phoneNo: phoneNo
        }))
    }

    // const [selectedMember, setSelectedMember] = useState('');

    handleMemberChange(event: any) {
        this.setSelectedMember(event.target.value);
        this.setPhoneNo(event.target.value.contact_info)
    };

    setSelectedMember(member: ITeam) {
        this.setState({
            selectedMember: member
        })
    }

    getMessage(message: string) {
        if (message.startsWith('Dear')) {
            return message
        } else {
            return `Dear ${this.state.selectedMember?.name}  \n ${message}`
        }
    }

    render() {
        return (
            <Dialog open={this.state.open} onClose={this.handleClose} fullWidth={true}>
                <DialogTitle>SMS Server</DialogTitle>
                <DialogContent>
                    {/*<DialogContentText>*/}
                    {/*    To subscribe to this website, please enter your email address here. We*/}
                    {/*    will send updates occasionally.*/}
                    {/*</DialogContentText>*/}
                    <FormControl fullWidth={true}>
                        <Select
                            value={this.state.selectedMember}
                            onChange={this.handleMemberChange}
                            displayEmpty
                            inputProps={{'aria-label': 'Select a team member'}}

                        >
                            <MenuItem disabled>Select a team member</MenuItem>
                            {this.props.teams.map((member: ITeam, index: number) => (
                                //@ts-ignore
                                <MenuItem key={index} value={member}>
                                    {member.name}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                    <FormControl fullWidth>
                        <TextField
                            autoFocus
                            margin="dense"
                            id="phoneNo"
                            label={!this.state.selectedMember ? "Phone no" : ""}
                            // fullWidth
                            variant="standard"
                            value={this.state.phoneNo}
                            defaultValue={this.state.selectedMember?.contact_info}
                            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                this.setPhoneNo(event.target.value);
                            }}
                            style={{marginTop: '16px'}}
                        />
                    </FormControl>
                    <TextareaAutosize
                        aria-label="Message"
                        placeholder="Message"
                        value={this.state.selectedMember ? this.getMessage(this.state.message) : ""}
                        onChange={(event) => this.setMessage(event.target.value)}
                        style={{width: '100%', marginTop: '16px', minHeight: "100px"}}

                    />
                    <div id={"div-message"} style={{padding: "10px", font: "400 .9em 'Open Sans', sans-serif;"}}>
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.handleClose}>Close</Button>
                    <Button onClick={() => {
                        this.sendSMS()
                    }}>Send SMS</Button>
                </DialogActions>

            </Dialog>
        );
    }
}

export default SMSDialog
